(function () {
  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var btn = e.target.closest('[data-layout]');
    if (!btn) return;

    var section = btn.closest('[data-atomberg-cp]');
    if (!section) return;

    var grid = section.querySelector('[data-cp-products]');
    if (!grid) return;

    var layout = btn.getAttribute('data-layout');

    section.querySelectorAll('[data-layout]').forEach(function (b) {
      b.classList.toggle('atomberg-cp__layout-btn--active', b === btn);
    });

    // CSS handles per-card horizontal styles via the parent grid class,
    // so infinite-scroll-appended cards get the correct layout automatically.
    grid.classList.toggle('atomberg-cp__products--horizontal', layout === 'horizontal');
  });
})();
